import React from "react";
import "./mursidlerim.scss";
import { MuzafferAskiOzak } from "./muzaffer-ozak";
import { SeferDal } from "./sefer-dal";
interface MursidlerimProps {
    isFirstSubMenu: boolean;

}
interface MursidlerimState {
    Change: boolean;
}

class Mursidlerim extends React.Component<MursidlerimProps, MursidlerimState>{
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    render() {
        return (
            <section className="spiritual-guides-section">
                {
                    this.props.isFirstSubMenu ?
                        <MuzafferAskiOzak />
                        : <SeferDal />
                }

            </section>
        );
    }
}

export default Mursidlerim;